import config from '../config'
import { post, put } from './apiService'

export const REGISTRATION_APIS = {
  validateAgentCode: `${config.apiUrl}/api/registration/validate_agent_code`,
  registerUser: `${config.apiUrl}/api/registration`,
}

// Validate agent code
export const validateAgentCode = (agentCode: string, successCallback: (data: any, status: number) => void, errorCallback: (error: any) => void) => {
  put(
    REGISTRATION_APIS.validateAgentCode,
    successCallback,
    errorCallback,
    { agent_code: agentCode },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
}

// Register user with name and email
export const registerUser = (
  userData: {
    agent_code: string
    name: string
    email: string
    consent: boolean
  },
  successCallback: (data: any, status: number) => void,
  errorCallback: (error: any) => void
) => {
  post(
    REGISTRATION_APIS.registerUser,
    successCallback,
    errorCallback,
    {
      agent_code: userData.agent_code,
      full_name: userData.name,
      email: userData.email,
      consent: userData.consent,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
}
